export const initialsFromString = (str?: string | null, defaultInitials = 'NA') => {
  if (!str) return defaultInitials

  let initials = ''
  const split = str.split(' ')

  split?.forEach((s) => {
    if (s && s.length > 0) {
      initials = `${initials}${s.substring(0, 1)}`
    }
  })

  if (initials.length > 2) {
    initials = `${initials[0]}${initials.substring(initials.length - 1)}`
  }

  return initials?.toUpperCase()
}
